export const tipologiaStruttura = {
    ASD: { value: "ASD", label: "ASD" },
    SSD: { value: "SSD", label: "SSD" },
    //FREELANCER: { value: "FREELANCER", label: "Libero professionista" },
    INDIVIDUAL_COMPANY: { value: "INDIVIDUAL_COMPANY", label: "Ditta individuale" },
    CAPITAL_COMPANY: { value: "CAPITAL_COMPANY", label: "SRL / SPA" },
    // Associazione o società tra professionisti (04/11/2026): funziona come SRL / SPA
    ATP_STP: { value: "ATP_STP", label: "ATP / STP" },
};

// SRL / SPA e ATP / STP hanno sempre il regime fiscale ordinario (RF01), che non si sceglie
export const haRegimeOrdinario = (clubNature) =>
    clubNature === tipologiaStruttura.CAPITAL_COMPANY.value || clubNature === tipologiaStruttura.ATP_STP.value;

export const fiscalRegime = [
    { value: "RF01", label: "Ordinario" },
    //{ value: "RF02", label: "Minimi" },
    { value: "RF19", label: "Forfettario" },
];

export const italianProvinces = [
    { value: "AG", label: "Agrigento" },
    { value: "AL", label: "Alessandria" },
    { value: "AN", label: "Ancona" },
    { value: "AO", label: "Aosta" },
    { value: "AR", label: "Arezzo" },
    { value: "AP", label: "Ascoli Piceno" },
    { value: "AT", label: "Asti" },
    { value: "AV", label: "Avellino" },
    { value: "BA", label: "Bari" },
    { value: "BT", label: "Barletta-Andria-Trani" },
    { value: "BL", label: "Belluno" },
    { value: "BN", label: "Benevento" },
    { value: "BG", label: "Bergamo" },
    { value: "BI", label: "Biella" },
    { value: "BO", label: "Bologna" },
    { value: "BZ", label: "Bolzano" },
    { value: "BS", label: "Brescia" },
    { value: "BR", label: "Brindisi" },
    { value: "CA", label: "Cagliari" },
    { value: "CL", label: "Caltanissetta" },
    { value: "CB", label: "Campobasso" },
    { value: "CE", label: "Caserta" },
    { value: "CT", label: "Catania" },
    { value: "CZ", label: "Catanzaro" },
    { value: "CH", label: "Chieti" },
    { value: "CO", label: "Como" },
    { value: "CS", label: "Cosenza" },
    { value: "CR", label: "Cremona" },
    { value: "KR", label: "Crotone" },
    { value: "CN", label: "Cuneo" },
    { value: "EN", label: "Enna" },
    { value: "FM", label: "Fermo" },
    { value: "FE", label: "Ferrara" },
    { value: "FI", label: "Firenze" },
    { value: "FG", label: "Foggia" },
    { value: "FC", label: "Forlì-Cesena" },
    { value: "FR", label: "Frosinone" },
    { value: "GE", label: "Genova" },
    { value: "GO", label: "Gorizia" },
    { value: "GR", label: "Grosseto" },
    { value: "IM", label: "Imperia" },
    { value: "IS", label: "Isernia" },
    { value: "SP", label: "La Spezia" },
    { value: "AQ", label: "L'Aquila" },
    { value: "LT", label: "Latina" },
    { value: "LE", label: "Lecce" },
    { value: "LC", label: "Lecco" },
    { value: "LI", label: "Livorno" },
    { value: "LO", label: "Lodi" },
    { value: "LU", label: "Lucca" },
    { value: "MC", label: "Macerata" },
    { value: "MN", label: "Mantova" },
    { value: "MS", label: "Massa-Carrara" },
    { value: "MT", label: "Matera" },
    { value: "ME", label: "Messina" },
    { value: "MI", label: "Milano" },
    { value: "MO", label: "Modena" },
    { value: "MB", label: "Monza e della Brianza" },
    { value: "NA", label: "Napoli" },
    { value: "NO", label: "Novara" },
    { value: "NU", label: "Nuoro" },
    { value: "OR", label: "Oristano" },
    { value: "PD", label: "Padova" },
    { value: "PA", label: "Palermo" },
    { value: "PR", label: "Parma" },
    { value: "PV", label: "Pavia" },
    { value: "PG", label: "Perugia" },
    { value: "PU", label: "Pesaro e Urbino" },
    { value: "PE", label: "Pescara" },
    { value: "PC", label: "Piacenza" },
    { value: "PI", label: "Pisa" },
    { value: "PT", label: "Pistoia" },
    { value: "PN", label: "Pordenone" },
    { value: "PZ", label: "Potenza" },
    { value: "PO", label: "Prato" },
    { value: "RG", label: "Ragusa" },
    { value: "RA", label: "Ravenna" },
    { value: "RC", label: "Reggio Calabria" },
    { value: "RE", label: "Reggio Emilia" },
    { value: "RI", label: "Rieti" },
    { value: "RN", label: "Rimini" },
    { value: "RM", label: "Roma" },
    { value: "RO", label: "Rovigo" },
    { value: "SA", label: "Salerno" },
    { value: "SS", label: "Sassari" },
    { value: "SV", label: "Savona" },
    { value: "SI", label: "Siena" },
    { value: "SR", label: "Siracusa" },
    { value: "SO", label: "Sondrio" },
    { value: "SU", label: "Sud Sardegna" },
    { value: "TA", label: "Taranto" },
    { value: "TE", label: "Teramo" },
    { value: "TR", label: "Terni" },
    { value: "TO", label: "Torino" },
    { value: "TP", label: "Trapani" },
    { value: "TN", label: "Trento" },
    { value: "TV", label: "Treviso" },
    { value: "TS", label: "Trieste" },
    { value: "UD", label: "Udine" },
    { value: "VA", label: "Varese" },
    { value: "VE", label: "Venezia" },
    { value: "VB", label: "Verbano-Cusio-Ossola" },
    { value: "VC", label: "Vercelli" },
    { value: "VR", label: "Verona" },
    { value: "VV", label: "Vibo Valentia" },
    { value: "VI", label: "Vicenza" },
    { value: "VT", label: "Viterbo" }
];  

export const bookingSubscriptionExpirationType = [
	{ value: "CALENDAR_YEAR_END", label: "Fine anno solare" },
	{ value: "MONTHLY", label: "Mensile" },
	{ value: "QUARTERLY", label: "Trimestrale" },
	{ value: "SEMIANNUAL", label: "Semestrale" },
	{ value: "ANNUAL", label: "Annuale" },
	{ value: "FIXED_DATE", label: "Data fissa" }
];

export const bloodTypes = [
	{ value: "A_POSITIVE", label: "A positivo" },
	{ value: "A_NEGATIVE", label: "A negativo" },
	{ value: "B_POSITIVE", label: "B positivo" },
	{ value: "B_NEGATIVE", label: "B negativo" },
	{ value: "AB_POSITIVE", label: "AB positivo" },
	{ value: "AB_NEGATIVE", label: "AB negativo" },
	{ value: "O_POSITIVE", label: "0 positivo" },
	{ value: "O_NEGATIVE", label: "0 negativo" }
];

export const foodIntollerances = [
	{ value: "GLUTEN", label: "Glutine" },
	{ value: "LACTOSE", label: "Lattosio" },
	{ value: "NUTS", label: "Noccioline" },
	{ value: "SHELLFISH", label: "Molluschi" },
	{ value: "EGGS", label: "Uova" },
	{ value: "FISH", label: "Pesce" },
	{ value: "SOY", label: "Soia" },
	{ value: "CELERY", label: "Sedano" },
    { value: "MUSTARD", label: "Mostarda" },
    { value: "SESAME", label: "Sesamo" },
    { value: "SULPHITES", label: "Solfiti" },
    { value: "LUPIN", label: "Lupini" },
    { value: "MOLLUSCS", label: "Molluschi" }
];

export const foodAllergies = [
	{ value: "GLUTEN", label: "Glutine" },
	{ value: "LACTOSE", label: "Lattosio" },
	{ value: "NUTS", label: "Noccioline" },
	{ value: "SHELLFISH", label: "Molluschi" },
	{ value: "EGGS", label: "Uova" },
	{ value: "FISH", label: "Pesce" },
	{ value: "SOY", label: "Soia" },
	{ value: "CELERY", label: "Sedano" },
    { value: "MUSTARD", label: "Mostarda" },
    { value: "SESAME", label: "Sesamo" },
    { value: "SULPHITES", label: "Solfiti" },
    { value: "LUPIN", label: "Lupini" },
    { value: "MOLLUSCS", label: "Molluschi" }
];

export const sports = [
    { value: "ALPINE_INLINE", label: "Alpine inline" },
    { value: "ARMI_SPORTIVE_DA_CACCIA", label: "Armi sportive da caccia" },
    { value: "ARRAMPICATA", label: "Arrampicata" },
    { value: "ARTI_MARZIALI", label: "Arti marziali" },
    { value: "ATLETICA_LEGGERA", label: "Atletica leggera" },
    { value: "AUTO", label: "Auto" },
    { value: "BADMINTON", label: "Badminton" },
    { value: "BASEBALL", label: "Baseball" },
    { value: "BASKETBALL", label: "Basket" },
    { value: "BEACH_BASKET", label: "Beach Basket" },
    { value: "BEACH_FOOTBALL_AMERICANO", label: "Beach football americano" },
    { value: "BEACH_GOLF", label: "Beach golf" },
    { value: "BEACH_HANDBALL", label: "Beach handball" },
    { value: "BEACH_HOCKEY", label: "Beach hockey" },
    { value: "BEACH_RUGBY", label: "Beach rugby" },
    { value: "BEACH_SOCCER", label: "Beach soccer" },
    { value: "BEACH_TENNIS", label: "Beach tennis" },
    { value: "BEACH_VOLLEY", label: "Beach volley" },
    { value: "BILIARDO", label: "Biliardo" },
    { value: "BOB", label: "Bob" },
    { value: "BOCCE", label: "Bocce" },
    { value: "BOWLING", label: "Bowling" },
    { value: "BRIDGE", label: "Bridge" },
    { value: "FOOTBALL", label: "Calcio" },
    { value: "FIVE_A_SIDE_FOOTBALL", label: "Calcio a 5" },
    { value: "CANOA", label: "Canoa" },
    { value: "CANOTTAGGIO", label: "Canottaggio" },
    { value: "BIKING", label: "Ciclismo" },
    { value: "CINOFILA", label: "Cinofila" },
    { value: "COMBATTIMENTO", label: "Combattimento" },
    { value: "RUNNING", label: "Corsa" },
    { value: "CRICKET", label: "Cricket" },
    { value: "CRONOMETRAGGIO", label: "Cronometraggio" },
    { value: "CROSSFIT", label: "Crossfit" },
    { value: "CURLING", label: "Curling" },
    { value: "DAMA", label: "Dama" },
    { value: "DANZA", label: "Danza" },
    { value: "DRAGON_BOAT", label: "Dragon boat" },
    { value: "EQUITAZIONE", label: "Equitazione" },
    { value: "CROSS_COUNTRY_SKIING", label: "Fondo" },
    { value: "FOOTBALL_AMERICANO", label: "Football americano" },
    { value: "GINNASTICA", label: "Ginnastica" },
    { value: "GIOCHI_TRADIZIONALI", label: "Giochi tradizionali" },
    { value: "GOLF", label: "Golf" },
    { value: "HOCKEY", label: "Hockey" },
    { value: "HOCKEY_A_ROTELLE", label: "Hockey a rotelle" },
    { value: "ICE_HOCKEY", label: "Hockey su ghiaccio" },
    { value: "HYROX", label: "Hyrox" },
    { value: "ICE_STOCK", label: "Ice stock" },
    { value: "INLINE_FREESTYLE", label: "Inline freestyle" },
    { value: "JUDO", label: "Judo" },
    { value: "KARATE", label: "Karate" },
    { value: "KICKBOXING", label: "Kickboxing" },
    { value: "KORFBALL", label: "Korfball" },
    { value: "LACROSSE", label: "Lacrosse" },
    { value: "LOTTA", label: "Lotta" },
    { value: "MEDICINA_DELLO_SPORT", label: "Medicina dello sport" },
    { value: "MONOPATTINO", label: "Monopattino" },
    { value: "MOTO", label: "Moto" },
    { value: "NAUTICA", label: "Nautica" },
    { value: "NINJA", label: "Ninja" },
    { value: "NORDIC_WALKING", label: "Nordic walking" },
    { value: "SWIMMING", label: "Nuoto" },
    { value: "ORIENTEERING", label: "Orienteering" },
    { value: "PADEL", label: "Padel" },
    { value: "PAINTBALL", label: "Paintball" },
    { value: "PALLAMANO", label: "Pallamano" },
    { value: "PALLANUOTO", label: "Pallanuoto" },
    { value: "PALLAPUGNO", label: "Pallapugno" },
    { value: "PALLA_TAMBURELLO", label: "Palla tamburello" },
    { value: "VOLLEYBALL", label: "Pallavolo" },
    { value: "PATTINAGGIO_A_ROTELLE", label: "Pattinaggio a rotelle" },
    { value: "PATTINAGGIO_SU_GHIACCIO", label: "Pattinaggio su ghiaccio" },
    { value: "PENTATHLON", label: "Pentathlon" },
    { value: "PESCA_DI_SUPERFICIE", label: "Pesca di superficie" },
    { value: "PESISTICA", label: "Pesistica" },
    { value: "PICKLEBALL", label: "Pickleball" },
    { value: "PUGILATO", label: "Pugilato" },
    { value: "RAFTING", label: "Rafting" },
    { value: "ROLLER_DERBY", label: "Roller derby" },
    { value: "RUGBY", label: "Rugby" },
    { value: "SALTO_CON_SCI", label: "Salto con sci" },
    { value: "SCACCHI", label: "Scacchi" },
    { value: "SCHERMA", label: "Scherma" },
    { value: "SKIING", label: "Sci" },
    { value: "SCI_NAUTICO", label: "Sci nautico" },
    { value: "SKATEBOARDING", label: "Skateboarding" },
    { value: "SKELETON", label: "Skeleton" },
    { value: "SKIROLL", label: "Skiroll" },
    { value: "SLITTINO", label: "Slittino" },
    { value: "SNOW_RUGBY", label: "Snow rugby" },
    { value: "SNOWBOARD", label: "Snowboard" },
    { value: "SOFT_AIR", label: "Soft air" },
    { value: "SOFTBALL", label: "Softball" },
    { value: "SPARTAN", label: "Spartan" },
    { value: "SQUASH", label: "Squash" },
    { value: "SUP", label: "SUP" },
    { value: "SURF", label: "Surf" },
    { value: "TAEKWONDO", label: "Taekwondo" },
    { value: "TENNIS", label: "Tennis" },
    { value: "TENNIS_TAVOLO", label: "Tennis tavolo" },
    { value: "TIRO_A_SEGNO", label: "Tiro a segno" },
    { value: "TIRO_A_VOLO", label: "Tiro a volo" },
    { value: "TIRO_CON_ARCO", label: "Tiro con arco" },
    { value: "TIRO_DINAMICO", label: "Tiro dinamico" },
    { value: "TRIATHLON", label: "Triathlon" },
    { value: "TWIRLING", label: "Twirling" },
    { value: "VELA", label: "Vela" },
    { value: "VOGA_IN_PIEDI", label: "Voga in piedi" },
    { value: "WAKEBOARD", label: "Wakeboard" },
    { value: "WAKE_SURF", label: "Wake surf" },
    { value: "YOGA", label: "Yoga" }
];

export const traumas = [
    { value: "HEAD", label: "Testa" },
    { value: "NECK", label: "Collo" },
    { value: "CHEST", label: "Torace" },
    { value: "ABDOMEN", label: "Addome" },
    { value: "PELVIS", label: "Bacino" },
    { value: "UPPER_BACK", label: "Schiena superiore" },
    { value: "LOWER_BACK", label: "Schiena inferiore" },
    { value: "UPPER_EXTREMITIES", label: "Estremità superiori" },
    { value: "LOWER_EXTREMITIES", label: "Estremità inferiori" },
    { value: "SKIN", label: "Pelle" },
    { value: "OTHER", label: "Altro" },
    { value: "LEFT_FOOT", label: "Piede sinistro" },
    { value: "RIGHT_FOOT", label: "Piede destro" },
    { value: "LEFT_HAND", label: "Mano sinistra" },
    { value: "RIGHT_HAND", label: "Mano destra" },
    { value: "LEFT_LEG", label: "Gamba sinistra" },
    { value: "RIGHT_LEG", label: "Gamba destra" },
    { value: "LEFT_WRIST", label: "Polso sinistro" },
    { value: "RIGHT_WRIST", label: "Polso destro" },
    { value: "LEFT_ANKLE", label: "Caviglia sinistra" },
    { value: "RIGHT_ANKLE", label: "Caviglia destra" },
    { value: "LEFT_ELBOW", label: "Gomito sinistro" },
    { value: "RIGHT_ELBOW", label: "Gomito destro" },
    { value: "LEFT_KNEE", label: "Ginocchio sinistro" },
    { value: "RIGHT_KNEE", label: "Ginocchio destro" },
    { value: "LEFT_ARM", label: "Braccio sinistro" },
    { value: "RIGHT_ARM", label: "Braccio destro" },
    { value: "LEFT_GROIN", label: "Inguine sinistro" },
    { value: "RIGHT_GROIN", label: "Inguine destro" }
];

export const medicalOperations = [
    { value: "HEAD", label: "Testa" },
    { value: "NECK", label: "Collo" },
    { value: "CHEST", label: "Torace" },
    { value: "ABDOMEN", label: "Addome" },
    { value: "PELVIS", label: "Bacino" },
    { value: "UPPER_BACK", label: "Schiena superiore" },
    { value: "LOWER_BACK", label: "Schiena inferiore" },
    { value: "UPPER_EXTREMITIES", label: "Estremità superiori" },
    { value: "LOWER_EXTREMITIES", label: "Estremità inferiori" },
    { value: "SKIN", label: "Pelle" },
    { value: "OTHER", label: "Altro" },
    { value: "LEFT_FOOT", label: "Piede sinistro" },
    { value: "RIGHT_FOOT", label: "Piede destro" },
    { value: "LEFT_HAND", label: "Mano sinistra" },
    { value: "RIGHT_HAND", label: "Mano destra" },
    { value: "LEFT_LEG", label: "Gamba sinistra" },
    { value: "RIGHT_LEG", label: "Gamba destra" },
    { value: "LEFT_WRIST", label: "Polso sinistro" },
    { value: "RIGHT_WRIST", label: "Polso destro" },
    { value: "LEFT_ANKLE", label: "Caviglia sinistra" },
    { value: "RIGHT_ANKLE", label: "Caviglia destra" }
];

export const bmiClass = [
    { value: "NORMAL_WEIGHT", label: "normopeso" },
    { value: "OVERWEIGHT", label: "sovrappeso" },
    { value: "SEVERE_THINNESS", label: "grave sottopeso" },
    { value: "UNDERWEIGHT", label: "sottopeso" },
    { value: "UNKWNOWN", label: "sconosciuto" },
    { value: "OBESE_CLASS_1", label: "obeso classe 1" },
    { value: "OBESE_CLASS_2", label: "obeso classe 2" },
    { value: "OBESE_CLASS_3", label: "obeso classe 3" }
];

export const sportsRoles = [
    // Football roles
    { value: "GOALKEEPER", label: "POR - Portiere", sport: "FOOTBALL" },
    { value: "CENTER_BACK", label: "DC - Difensore centrale", sport: "FOOTBALL" },
    { value: "RIGHT_BACK", label: "TD - Terzino destro", sport: "FOOTBALL" },
    { value: "LEFT_BACK", label: "TS - Terzino sinistro", sport: "FOOTBALL" },
    { value: "RIGHT_WING_BACK", label: "ADA - Ala destra arretrata", sport: "FOOTBALL" },
    { value: "LEFT_WING_BACK", label: "ASA - Ala sinistra arretrata", sport: "FOOTBALL" },
    { value: "CENTRAL_MIDFIELDER", label: "CC - Centrocampista centrale", sport: "FOOTBALL" },
    { value: "DEFENSIVE_MIDFIELDER", label: "CDC - Centrocampista difensivo centrale", sport: "FOOTBALL" },
    { value: "CENTRAL_ATTACKING_MIDFIELDER", label: "COC - Centrocampista offensivo centrale", sport: "FOOTBALL" },
    { value: "LEFT_MIDFIELDER", label: "ES - Esterno sinistro", sport: "FOOTBALL" },
    { value: "RIGHT_MIDFIELDER", label: "ED - Esterno destro", sport: "FOOTBALL" },
    { value: "RIGHT_FORWARD", label: "PD - Punta destra", sport: "FOOTBALL" },
    { value: "LEFT_FORWARD", label: "PS - Punta sinistra", sport: "FOOTBALL" },
    { value: "RIGHT_WINGER", label: "AD - Ala destra", sport: "FOOTBALL" },
    { value: "LEFT_WINGER", label: "AS - Ala sinistra", sport: "FOOTBALL" },
    { value: "STRIKER", label: "AT - Attaccante", sport: "FOOTBALL" },
  
    // Five-a-side football roles
    { value: "GOALKEEPER", label: "Portiere", sport: "FIVE_A_SIDE_FOOTBALL" },
    { value: "DEFENDER", label: "Difensore", sport: "FIVE_A_SIDE_FOOTBALL" },
    { value: "INTERMEDIATE", label: "Intermedio", sport: "FIVE_A_SIDE_FOOTBALL" },
    { value: "PIVOT", label: "Attaccante", sport: "FIVE_A_SIDE_FOOTBALL" },
    { value: "UNIVERSAL", label: "Universale", sport: "FIVE_A_SIDE_FOOTBALL" },
  
    // Volleyball roles
    { value: "SETTER", label: "Alzatore", sport: "VOLLEYBALL" },
    { value: "OUTSIDE_HITTER", label: "Laterale", sport: "VOLLEYBALL" },
    { value: "OPPOSITE_HITTER", label: "Opposto", sport: "VOLLEYBALL" },
    { value: "MIDDLE_BLOCKER", label: "Centrale", sport: "VOLLEYBALL" },
    { value: "LIBERO", label: "Libero", sport: "VOLLEYBALL" },
  
    // Basketball roles
    { value: "POINT_GUARD", label: "Playmaker", sport: "BASKETBALL" },
    { value: "SHOOTING_GUARD", label: "Guardia tiratrice", sport: "BASKETBALL" },
    { value: "SMALL_FORWARD", label: "Ala piccola", sport: "BASKETBALL" },
    { value: "POWER_FORWARD", label: "Ala grande", sport: "BASKETBALL" },
    { value: "CENTER", label: "Centro", sport: "BASKETBALL" },
  
    // Hockey roles
    { value: "GOALKEEPER", label: "Portiere", sport: "HOCKEY" },
    { value: "DEFENDER", label: "Difensore", sport: "HOCKEY" },
    { value: "WINGER", label: "Ala", sport: "HOCKEY" },
    { value: "CENTER", label: "Centro", sport: "HOCKEY" },
  
    // Rugby roles
    { value: "RIGHT_PROP", label: "Pilone destro", sport: "RUGBY" },
    { value: "LEFT_PROP", label: "Pilone sinistro", sport: "RUGBY" },
    { value: "HOOKER", label: "Tallonatore", sport: "RUGBY" },
    { value: "LOCK", label: "Seconda linea", sport: "RUGBY" },
    { value: "FLANKER", label: "Terza linea ala", sport: "RUGBY" },
    { value: "NUMBER_EIGHT", label: "Terza linea centro", sport: "RUGBY" },
    { value: "SCRUM_HALF", label: "Mediano di mischia", sport: "RUGBY" },
    { value: "FLY_HALF", label: "Mediano di apertura", sport: "RUGBY" },
    { value: "CENTRE", label: "Centro", sport: "RUGBY" },
    { value: "WING", label: "Ala", sport: "RUGBY" },
    { value: "FULLBACK", label: "Estremo", sport: "RUGBY" }
  ];
  
  export const bookingCourseExpirationType = [
	{ value: "CALENDAR_YEAR_END", label: "Fine anno solare" },
	{ value: "MONTHLY", label: "Mensile" },
	{ value: "QUARTERLY", label: "Trimestrale" },
	{ value: "SEMIANNUAL", label: "Semestrale" },
	{ value: "ANNUAL", label: "Annuale" }
];
// Ruoli accettati dal backend per gli sport praticati (SportRole dell'openapi:
// solo questi sei sport ne prevedono uno). L'elenco `sportsRoles` qui sopra è
// più fine per il calcio ma non è validato dal backend, quindi in creazione
// player si usa questa mappa.
export const practicedSportsRoles = {
	FOOTBALL: [
		{ value: "GOALKEEPER", label: "Portiere" },
		{ value: "DEFENDER", label: "Difensore" },
		{ value: "MIDFIELDER", label: "Centrocampista" },
		{ value: "STRIKER", label: "Attaccante" }
	],
	FIVE_A_SIDE_FOOTBALL: [
		{ value: "GOALKEEPER", label: "Portiere" },
		{ value: "DEFENDER", label: "Difensore" },
		{ value: "INTERMEDIATE", label: "Intermedio" },
		{ value: "PIVOT", label: "Pivot" },
		{ value: "UNIVERSAL", label: "Universale" }
	],
	VOLLEYBALL: [
		{ value: "SETTER", label: "Alzatore" },
		{ value: "OUTSIDE_HITTER", label: "Laterale" },
		{ value: "OPPOSITE_HITTER", label: "Opposto" },
		{ value: "MIDDLE_BLOCKER", label: "Centrale" },
		{ value: "LIBERO", label: "Libero" }
	],
	BASKETBALL: [
		{ value: "POINT_GUARD", label: "Playmaker" },
		{ value: "SHOOTING_GUARD", label: "Guardia tiratrice" },
		{ value: "SMALL_FORWARD", label: "Ala piccola" },
		{ value: "POWER_FORWARD", label: "Ala grande" },
		{ value: "CENTER", label: "Centro" }
	],
	ICE_HOCKEY: [
		{ value: "GOALKEEPER", label: "Portiere" },
		{ value: "DEFENDER", label: "Difensore" },
		{ value: "WINGER", label: "Ala" },
		{ value: "CENTER", label: "Centro" }
	],
	RUGBY: [
		{ value: "RIGHT_PROP", label: "Pilone destro" },
		{ value: "LEFT_PROP", label: "Pilone sinistro" },
		{ value: "HOOKER", label: "Tallonatore" },
		{ value: "LOCK", label: "Seconda linea" },
		{ value: "FLANKER", label: "Terza linea ala" },
		{ value: "NUMBER_EIGHT", label: "Terza linea centro" },
		{ value: "SCRUM_HALF", label: "Mediano di mischia" },
		{ value: "FLY_HALF", label: "Mediano di apertura" },
		{ value: "CENTRE", label: "Centro" },
		{ value: "WING", label: "Ala" },
		{ value: "FULLBACK", label: "Estremo" }
	]
};
